import { render, staticRenderFns } from "./BuildingsList.vue?vue&type=template&id=fad12f6e&lang=pug&"
import script from "./BuildingsList.vue?vue&type=script&lang=ts&"
export * from "./BuildingsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports